import showSnackbar from '../snackbar/snackbar'
import { isMobile, copyToClipboard } from '../../../helper-functions'
import swapButton from '../../atoms/buttons/share-button'

/**
 * Shows the share button pop-up.
 **/
export default function shareDrawer() {
  const share = document.querySelector( '.js-share' )

  if ( !share ) {
    return
  }

  const shareButton = share.querySelector( '.js-share-button' )
  const shareDrawer = share.querySelector( '.js-share-modal' )
  const copyButton = share.querySelector( '.js-share-copy' )
  const mailButton = share.querySelector( '.js-share-mail' )
  const currentUrl = window.location.href

  shareButton.onclick = () => {
    if ( shareDrawer.classList.contains( 'drawer-open' ) ) {
      closeDrawer()
    } else {
      openDrawer()
    }
  }

  copyButton.onclick = () => {
    copyToClipboard( currentUrl )

    closeDrawer()

    showSnackbar( share.dataset.copyText )
  }

  mailButton.onclick = () => {
    closeDrawer()
  }

  /**
   * Opens the share drawer.
   **/
  function openDrawer() {
    shareDrawer.classList.remove( 'invisible' )
    shareDrawer.classList.add( 'translate-y-full', 'drawer-open' )

    const shareButtonWidth = shareButton.offsetWidth
    shareButton.setAttribute( 'style', `width: ${shareButtonWidth}px` )

    swapButton( true )
  }

  /**
   * Closes the share drawer.
   **/
  function closeDrawer() {
    shareDrawer.classList.remove( 'translate-y-full', 'drawer-open' )
    shareDrawer.classList.add( 'invisible' )
    swapButton( false )
  }

  window.onresize = () => {
    if ( shareDrawer.classList.contains( 'drawer-open' ) && isMobile ) {
      shareButton.setAttribute( 'style', 'width: 100%' )
      return
    } else if ( shareDrawer.classList.contains( 'drawer-open' ) ) {
      return
    }
    shareButton.removeAttribute( 'style' )
  }
}
